import * as ExperiencesClient from 'flux/clients/experiences';

import { ActionType } from './model';

export type ExperienceAvailabilityActions = {
  setAvailableDays(data: Record<string, string[]>): void;
  resetAvailableDays(): void;
  fetchAvailableTimes(experienceId: string, selectedDate: string): void;
  setAvailableTimes(date: string, data: Record<string, string[]>): void;
  resetAvailableTimes(): void;
};

function actionsFactory(
  dispatch: (action: ActionType) => void,
): ExperienceAvailabilityActions {
  return {
    setAvailableDays(data) {
      dispatch({ type: 'FETCH_DAYS_SUCCESS', payload: { data } });
    },
    fetchAvailableTimes(experienceId, selectedDate) {
      dispatch({ type: 'FETCH_TIMES', payload: { date: selectedDate } });
      ExperiencesClient.fetchAvailableTimes({
        experienceId,
        date: selectedDate,
      })
        .then((data) =>
          dispatch({
            type: 'FETCH_TIMES_SUCCESS',
            payload: { date: selectedDate, data },
          }),
        )
        .catch((error) =>
          dispatch({
            type: 'FETCH_TIMES_ERROR',
            payload: { date: selectedDate, error },
          }),
        );
    },
    setAvailableTimes(date, data) {
      dispatch({ type: 'FETCH_TIMES_SUCCESS', payload: { date, data } });
    },
    resetAvailableDays() {
      dispatch({ type: 'RESET_DAYS' });
    },
    resetAvailableTimes() {
      dispatch({ type: 'RESET_TIMES' });
    },
  };
}

export default actionsFactory;
